// src/components/TimerBadge/index.tsx

import React, { useEffect, useState } from "react";
import styles from "./index.module.css";

interface TimerBadgeProps {
  /** Local or external path to the timer icon (SVG, PNG, etc.) */
  iconSrc: string;

  /** Start the timer at this many seconds. Defaults to 0. */
  initialSeconds?: number;
}

/**
 * TimerBadge: A 68×26 pill-shaped blue background with a small icon (14×16.333)
 * and a dynamic MM:SS text in Product Sans. The timer starts counting
 * upon mounting.
 */
const TimerBadge: React.FC<TimerBadgeProps> = ({
  iconSrc,
  initialSeconds = 0,
}) => {
  const [elapsedSeconds, setElapsedSeconds] = useState(initialSeconds);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setElapsedSeconds((prev) => prev + 1);
    }, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  // Format as MM:SS
  const minutes = Math.floor(elapsedSeconds / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (elapsedSeconds % 60).toString().padStart(2, "0");

  return (
    <div className={styles.timerBadge}>
      <img src={iconSrc} alt="Timer Icon" className={styles.timerIcon} />
      <span className={styles.timerText}>
        {minutes}:{seconds}
      </span>
    </div>
  );
};

export default TimerBadge;
